import React from "react";
import ReactApexChart from "react-apexcharts";

const BarChart = (props: any) => {
  const {categories, seriesData, seriesName = "series"} = props

  const series = [
    {
      name: seriesName,
      data: seriesData,
    },
  ];
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },

    colors: ["#2ab57d"],
    grid: {
      borderColor: "#f1f1f1",
    },
    xaxis: {
      categories: categories,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={Math.max(350, seriesData.length * 25)}
      className="apex-charts"
    />
  );
};

export default BarChart;
